import { useFrame } from "@react-three/fiber"
import { mainStore } from "../../store"
import { useScroll } from "@react-three/drei"
import { useEffect } from "react"



export default function ScrollListener() {


    const data = useScroll()
    // const { width, height } = useThree((state) => state.viewport)


    // Store
    const currentChapter = mainStore.useStore(s => s.current)
    const chapterChangeRequested = mainStore.useStore(s => s.current.chapterChangeRequested)
    const preventChapterUpdate = mainStore.useStore(s => s.preventChapterUpdate)
    const totalPages = mainStore.useStore(s => s.totalPages)


    useEffect(() => {
        console.log('chapterchange => ', currentChapter)
        if (currentChapter.chapter !== 'null' && !preventChapterUpdate) {
            mainStore.preventChapterUpdate(true)
            data.scroll.current = currentChapter.start
            data.el.scrollTop = ((totalPages * currentChapter.start) * window.innerHeight)
            setTimeout(() => mainStore.preventChapterUpdate(false), 1000)
        }
        console.log(data)
    }, [currentChapter])

    useFrame(() => {
        // console.log(data.scroll.current)
    })
}